export default {
    PRODUCTION: 'production',
    DEBUG: 'debug',
    UNIT_TESTING: 'unit-testing',
    DEVELOPMENT: 'development'
};



/** WEBPACK FOOTER **
 ** ./src/environmentNames.js
 **/